import React from 'react';
import { Container } from 'reactstrap';

import formatIntl from '../Common/formatIntl';
import SectionHeader from '../Common/SectionHeader';
import SectionHeadingField from '../Common/SectionHeadingField';
import { withLayout } from '../PuckLayout';
import BrandColorsField from './BrandColorsField';
import ColorSwatch from './ColorSwatch';

const PuckColors = {
  get label() { return formatIntl('Brand Colors'); },
  fields: {
    sectionHeading: {
      type: 'custom',
      get label() { return formatIntl('Section Heading'); },
      render: (props) => <SectionHeadingField {...props} />,
    },
    colors: {
      type: 'custom',
      get label() { return formatIntl('Brand Colors'); },
      render: (props) => <BrandColorsField {...props} />,
    },
    shape: {
      type: 'radio',
      get label() { return formatIntl('Swatch shape'); },
      options: [
        { get label() { return formatIntl('Square'); }, value: 'square' },
        { get label() { return formatIntl('Circle'); }, value: 'circle' },
        { get label() { return formatIntl('Rectangle'); }, value: 'rectangle' },
      ],
    },
    size: {
      type: 'select',
      get label() { return formatIntl('Swatch size'); },
      options: [
        { get label() { return formatIntl('Extra small'); }, value: 'xs' },
        { get label() { return formatIntl('Small'); }, value: 'sm' },
        { get label() { return formatIntl('Medium'); }, value: 'md' },
        { get label() { return formatIntl('Large'); }, value: 'lg' },
        { get label() { return formatIntl('Extra large'); }, value: 'xl' },
      ],
    },
    layout: {
      type: 'radio',
      get label() { return formatIntl('Layout'); },
      options: [
        { get label() { return formatIntl('Columns'); }, value: 'column' },
        { get label() { return formatIntl('Rows'); }, value: 'row' },
      ],
    },
    columns: {
      type: 'number',
      get label() { return formatIntl('Columns'); },
      min: 1,
      max: 12,
    },
    align: {
      type: 'radio',
      get label() { return formatIntl('Content alignment'); },
      options: [
        { get label() { return formatIntl('Left'); }, value: 'left' },
        { get label() { return formatIntl('Center'); }, value: 'center' },
        { get label() { return formatIntl('Right'); }, value: 'right' },
      ],
    },
    showHex: {
      type: 'radio',
      get label() { return formatIntl('Hex value display'); },
      options: [
        { get label() { return formatIntl('Show'); }, value: true },
        { get label() { return formatIntl('Hide'); }, value: false },
      ],
    },
    showCopyBtn: {
      type: 'radio',
      get label() { return formatIntl('Show "Copy hex" button'); },
      options: [
        { get label() { return formatIntl('Show'); }, value: true },
        { get label() { return formatIntl('Hide'); }, value: false },
      ],
    },
  },
  get defaultProps() {
    return {
      sectionHeading: {
        title: formatIntl('Header'),
        subtitle: formatIntl('Subheader'),
        align: 'left',
      },
      colors: [
        {
          colorKey: 'default-1',
          hex: '#203444',
          title: formatIntl('Primary'),
          subtitle: formatIntl('Main brand color'),
        },
        {
          colorKey: 'default-2',
          hex: '#4f8ef7',
          title: formatIntl('Accent'),
          subtitle: formatIntl('Used for CTAs'),
        },
      ],
      shape: 'rectangle',
      size: 'xl',
      layout: 'column',
      columns: 4,
      align: 'left',
      showHex: true,
      showCopyBtn: true,
    };
  },
  render: ({
    colors,
    sectionHeading,
    sectionTitle,
    shape,
    size,
    layout,
    columns,
    align,
    showHex,
    showCopyBtn,
  }) => {
    const list = Array.isArray(colors) ? colors : [];
    const cols = layout === 'row' ? Math.min(columns || 1, 3) : (columns || 4);
    const headerTitle = sectionHeading?.title || sectionTitle || '';
    const headerSubtitle = sectionHeading?.subtitle || '';
    const headerAlign = sectionHeading?.align || 'left';
    const header = (
      <SectionHeader
        title={headerTitle}
        subtitle={headerSubtitle}
        align={headerAlign}
      />
    );

    return (
      <div className="custom-page-section">
        <Container className="puck-colors">
          {header}
          <div
            className={`puck-colors-grid puck-colors-grid--${layout} puck-colors-grid--cols-${cols}`}
          >
            {list.map((color, index) => (
              <ColorSwatch
                key={color.colorKey || `swatch-${index}`}
                color={color}
                shape={shape}
                size={size || 'md'}
                layout={layout}
                align={align || 'left'}
                showHex={!!showHex}
                showCopyBtn={!!showCopyBtn}
              />
            ))}
          </div>
        </Container>
      </div>
    );
  },
};

export default withLayout(PuckColors);
